import { NgModule } from '@angular/core';
import { ReferencesCmsComponents } from '@core/const';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        RetailRocketReferencesComponent: {
          module: () => import('./retail-rocket-references').then((m) => m.RetailRocketReferencesModule),
          cmsComponents: Object.values(ReferencesCmsComponents),
        },
      },
    }),
  ],
})
export class ReferenceUiLazyModule {}
